import { systemJSPrototype } from './systemjs';

/**
 * This hooks into the register pipeline and wraps the "exports" function.
 * this allows functions to retain their "name" as otherwise all exported
 * functions would be anonymous, greatly reducing the debugging ability of
 * stack traces and react component tree
 */
const isFunction = (val: any): val is Function => typeof val === 'function';
const systemRegister = systemJSPrototype.register;

systemJSPrototype.register = function (...args: any[]) {
  const factoryIndex = args.findIndex(isFunction);
  const origFactory = args[factoryIndex] as Function;
  args[factoryIndex] = function (origExports: any, origModule: any) {
    const namedExports = (name: string, val: any) => {
      if (isFunction(val) && !val.name) {
        try {
          Object.defineProperty(val, 'name', { value: name });
        } catch (e) {
          // noop
        }
      }
      return origExports(name, val);
    };
    return origFactory.call(this, namedExports, origModule);
  };
  systemRegister.apply(this, args);
};
